export default function DownArrowIcon () {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M7.41 7.83L12 12.41L16.59 7.83L18 9.24L12 15.24L6 9.24L7.41 7.83Z" fill="currentColor" />
    </svg>
  )
}